"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrForgotPasswordLinkWrapper = exports.FdrForgotPasswordFormWrapper = exports.FdrB2bForgotPasswordNotificationModal = exports.FdrB2bForgotPasswordModal = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
exports.FdrB2bForgotPasswordModal = (0, styled_components_1.default)(components_common_modals_1.WhiteBoxModal).attrs({
    name: 'b2bForgotPasswordFormOverlay',
})(({ theme }) => theme.modals.forgotPasswordModal);
exports.FdrB2bForgotPasswordNotificationModal = (0, styled_components_1.default)(components_common_modals_1.NotificationModal)(({ theme }) => ({
    '.modal-wrapper': theme.modals.smallModalWrapper,
}));
exports.FdrForgotPasswordFormWrapper = styled_components_1.default.form((0, util_theme_sxc_1.sx2CssThemeFn)({
    '.form-text': {
        mb: [3, 4],
    },
    '.form-submit-button': {
        width: '100%',
        mb: [3, '20px'],
    },
}));
exports.FdrForgotPasswordLinkWrapper = (0, styled_components_1.default)(core_basis_bs_button_1.BsButton)(({ theme }) => theme.buttons.linkBtn);
//# sourceMappingURL=fdr-b2b-forgot-password.styles.js.map